define('config/config.development', [

], function() {

    var config = {
        "debug": false,
        "environement": "development",
        "assets_url": window.maz_baseurl || "/",
        "ws_root_url": window.maz_rooturl || "",
        "ws_quickbuy_product": {
            "mobile": '{{ws_root_url}}/{{locale}}/get-quick-buy-product.json?productCode={{codeY}}',
            "desktop": '{{ws_root_url}}/beauty/{{locale}}/get-quick-buy-product.json?productCode={{codeY}}'
        },
        "ws_basket_product": { //TODO
            "mobile": "",
            "desktop": ""
        }
    };

    return config;
});
